module.exports = __webpack_public_path__ + "media/images/close_button-b4471e144631cc842ddacbe2e48e8de7.svg";